import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';
import { initBrowserMonitoring } from './lib/newrelic';

// Start New Relic Browser monitoring as early as possible.
// No-op when VITE_NEW_RELIC_* env vars are not configured.
initBrowserMonitoring();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
